import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function AhaMomentSection() {
  const statements = ['Algunas emociones que sientes nunca fueron tuyas.', 'Quizás estás viviendo una historia que no empezó contigo.', 'Lo que llamas autosabotaje, podría ser lealtad familiar invisible.'];
  return <section className="py-32 bg-charcoal text-beige-light relative overflow-hidden" data-id="element-20">
      {/* Subtle texture/gradient */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-charcoal via-[#1a1a1a] to-black opacity-80" data-id="element-21" />

      <div className="container mx-auto px-6 relative z-10 max-w-4xl" data-id="element-22">
        <div className="space-y-24 text-center" data-id="element-23">
          {statements.map((statement, index) => <FadeIn key={index} delay={0.2} duration={1} data-id="element-24">
              <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl italic leading-relaxed md:leading-snug text-balance" data-id="element-25">
                "{statement}"
              </h2>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}